export default __webpack_public_path__ + "static/media/mastercard_image.0d3c3475.svg";